import request from "./httpService";

const EMPLOYEE_ENDPOINT = '/employee';

const clockIn = (data) => {
    return request({
        method: 'POST',
        url: `${EMPLOYEE_ENDPOINT}/clock-in`,
        data
    });
};

const clockOut = () => {
    return request({
        method: 'POST',
        url: `${EMPLOYEE_ENDPOINT}/clock-out`
    });
};

const getMyStatus = () => {
    return request({
        method: 'GET',
        url: `${EMPLOYEE_ENDPOINT}/time/me`,
        params: { active: true }
    });
};

const getMyEntries = (params) => {
    return request({
        method: 'GET',
        url: `${EMPLOYEE_ENDPOINT}/time/me`,
        params
    });
};

export const TimeService = {
    clockIn,
    clockOut,
    getMyStatus,
    getMyEntries,
    getWithLimit: (from, to, filters, sortBy, signal, range) => request({
        method: 'GET',
        url: `/employee/time/withlimit/${from}/${to}`,
        params: { filters, sortBy, start: range?.start, end: range?.end },
        signal
    })
};
